import { DataProvider } from "../../entities/service/model/DataContext";
import { SupportProvider } from "../../entities/support/ui/SupportProvider";
import { UserProvider } from "../../entities/user/model/UserContext";

interface LayoutProps {
    children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <DataProvider>
            <UserProvider>
                <SupportProvider>
                    {children}
                </SupportProvider>
            </UserProvider>
        </DataProvider>
    );
};